import React from "react";
import { reloadPage } from "./Browser";

// What a visitor sees in place of a page that failed to render (see ErrorBoundary.js). It
// must not depend on anything that could be what broke -- no Layout, no context, no data
// -- so it is plain markup styled by the global stylesheet alone.
const CrashFallback = () => (
  <div className="container py-5 text-center" role="alert">
    <h1 className="h3 mb-3">Something went wrong</h1>
    <p className="mb-4">
      This page hit an error and could not finish loading. Reloading usually fixes it.
    </p>
    <button type="button" className="btn btn-primary me-2" onClick={reloadPage}>
      Reload page
    </button>
    {/* A plain link, not Gatsby's Link: a full page load starts the app from scratch,
        which is the point after a crash. */}
    <a className="btn btn-outline-secondary" href="/">
      Go to the home page
    </a>
  </div>
);

export { CrashFallback };
